function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "download");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u2693\\uFE0F-The-Shipyard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u260DQronoport-/-Foundation-/-icons-/-export",
  transform: "translate(-2.000000, -2.000000)",
  fill: "#06273A"
}, React.createElement("path", {
  d: "M15.2916838,10.2949865 L13.0016838,12.5949865 L13.0016838,3.00498648 C13.0016838,2.45270173 12.5539686,2.00498648 12.0016838,2.00498648 C11.4493991,2.00498648 11.0016838,2.45270173 11.0016838,3.00498648 L11.0016838,12.5949865 L8.71168381,10.2949865 C8.52391721,10.1056738 8.26832135,9.99918816 8.00168381,9.99918816 C7.73504627,9.99918816 7.47945041,10.1056738 7.29168381,10.2949865 C7.10237116,10.4827531 6.99588549,10.7383489 6.99588549,11.0049865 C6.99588549,11.271624 7.10237116,11.5272199 7.29168381,11.7149865 L11.2916838,15.7149865 C11.3867875,15.8060271 11.4989325,15.8773921 11.6216838,15.9249865 C11.8651452,16.0250045 12.1382225,16.0250045 12.3816838,15.9249865 C12.5044351,15.8773921 12.6165801,15.8060271 12.7116838,15.7149865 L16.7116838,11.7149865 C16.9653424,11.4613279 17.0644073,11.0916125 16.9715619,10.7451084 C16.8787164,10.3986044 16.6080659,10.1279539 16.2615619,10.0351084 C15.9150578,9.94226296 15.5453424,10.0413279 15.2916838,10.2949865 Z M21,14 C20.4477153,14 20,14.4477153 20,15 L20,19 C20,19.5522848 19.5522848,20 19,20 L4.99999999,20 C4.44771524,20 3.99999999,19.5522848 3.99999999,19 L3.99999999,15 C3.99999999,14.4477153 3.55228474,14 2.99999999,14 C2.44771524,14 1.99999999,14.4477153 1.99999999,15 L1.99999999,19 C1.99999999,20.6568543 3.34314574,22 4.99999999,22 L19,22 C20.6568543,22 22,20.6568543 22,19 L22,15 C22,14.4477153 21.5522848,14 21,14 Z",
  id: "download"
})));

var SvgDownload = function SvgDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download.846737b4.svg";
export { ForwardRef as ReactComponent };